import React from 'react';
import PropTypes from 'prop-types';
import {
  useDroppable,
} from '@dnd-kit/core';
import Grid from './Grid';

const DroppableContainer = ({
  children,
  columns = 5,
  id,
  ulStyle = {},
  items,
  getStyle = () => ({}),
}) => {
  const { over, isOver, setNodeRef } = useDroppable({
    id,
  });
  const isOverContainer = isOver || (over ? items.includes(over.id) : false);
  return (
    <Grid ref={setNodeRef} style={getStyle({ isOverContainer })} columns={columns} ulStyle={ulStyle}>
      {children}
    </Grid>
  );
};

DroppableContainer.propTypes = {
  ulStyle: PropTypes.shape(),
  children: PropTypes.arrayOf(PropTypes.shape()),
  columns: PropTypes.number,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape()),
  getStyle: PropTypes.func,
};

export default DroppableContainer;
